export const getMonitoringInstance = () => {
    const Cobrowse = window.Cobrowse;
    if (typeof Cobrowse === 'object' && Cobrowse !== null) {
        return Cobrowse.Monitoring;
    }
    else if ('Monitoring' in window) {
        return window.Monitoring;
    }
    else {
        return undefined;
    }
};
export const filterEvent = (allowedDebugLevel, currentEventType) => {
    switch (currentEventType) {
        case "1":
            return allowedDebugLevel !== "0";
        case "10":
            return allowedDebugLevel !== "0" && allowedDebugLevel !== "1";
        case "100":
            return allowedDebugLevel === "100" || allowedDebugLevel === "1000";
        case "1000":
            return allowedDebugLevel === "1000";
    }
    return false;
};
